// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5o-2";
export var blackBorderOnHover = "_5o-7";
export var cell = "_5o-6";
export var cellContainer = "_5o-3";
export var checked = "_5o-8";
export var disabled = "_5o-5";
export var featuredIconCellContainer = "_5o-9";
export var featuredIconTextContainer = "_5o-b";
export var featuredIconWrapper = "_5o-a";
export var noBorder = "_5o-c";
export var orangeSelectedRow = "_dr-3";
export var overflowableText = "_5o-0";
export var overflowableTextContainer = "_5o-1";
export var row = "_5p-0";
export var rowCheckboxCell = "_5o-4";
export var selectableTable = "_dr-2";